import React, { useEffect, useState } from "react";
import Button from "../common/Button/Button";
import api from "../../services/api";
import "./Learning.css";
import { useNavigate, useParams } from "react-router-dom";
import { REACT_APP_API_BASE_URL } from "../../apiurl";

const AddLearningModuleMaster = () => {

  const navigate = useNavigate();
  const { id } = useParams();
  const [formData, setFormData] = useState({
    modulename: "",
    modulebrief: "",
    moduleimage: null,
    learningcategory: null,
  });
  const [previewImage, setPreviewImage] = useState(null);
  const [learningcategory, setLearningCategory] = useState([])

  useEffect(() => {
    if (id) {
      api.get(`/learningmodules/${id}`)
        .then((res) => {
          setFormData({
            modulename: res.data.module_name,
            modulebrief: res.data.module_brief,
            moduleimage: res.data.module_image, // image will not be pre-populated
            learningcategory: res.data.id
          });
        })
        .catch((err) => console.error("Error loading module:", err));
    }
  }, [id]);

  const handleChange = (e) => {
    const { name, value, files } = e.target;
    if (name === "moduleimage") {
      setFormData((prev) => ({ ...prev, [name]: files[0] }));
    } else {
      setFormData((prev) => ({ ...prev, [name]: value }));
    }
  };

  const handleSubmit = (e) => {
    e.preventDefault();

    const form = new FormData();
    Object.entries(formData).forEach(([key, value]) => value && form.append(key, value));

    const apiCall = id
      ? api.put(`/learningmodules/${id}`, form)   // Edit mode
      : api.post(`/learningmodules`, form);       // Add mode

    apiCall
      .then(() => navigate("/learning"))
      .catch((error) => console.error("Error:", error));
  };

  useEffect(() => {
    api.get('/learningcategory')
      .then((response) => {
        setLearningCategory(response.data);
      })
      .catch((error) => {
        console.error('Error fetching learning Category:', error);
      });
  }, []);


  return (
    <div className="moduleFormContainer">
      <div className="moduleFormCard">

        <h2 className="moduleFormTitle"> {id ? "Edit Module Master" : "Create Module Master"}</h2>

        <form onSubmit={handleSubmit} className="moduleForm">

          <div className="formGrid">
            <div className="formGroup">
              <label>Module Name</label>
              <input
                type="text"
                name="modulename"
                value={formData.modulename}
                onChange={handleChange}
                required
              />
            </div>

            <div className="formGroup">
              <label>Module Brief</label>
              <textarea
                name="modulebrief"
                value={formData.modulebrief}
                onChange={handleChange}
                required
                style={{ minHeight: "5px" }}
              />
            </div>

            <div className="formGroup imageGroup">
              <label>Module Image</label>


              {formData.moduleimage && typeof formData.moduleimage === "string" && (
                <div className="imagePreview">
                  <img
                    src={`${REACT_APP_API_BASE_URL}uploads/moduleimages/${formData.moduleimage}`}
                    alt="Module"
                    style={{ cursor: "pointer", maxWidth: "120px", borderRadius: "8px" }}
                    onClick={() => setPreviewImage(`${REACT_APP_API_BASE_URL}uploads/moduleimages/${formData.moduleimage}`)}
                  />
                </div>
              )}


              <input type="file" name="moduleimage" onChange={handleChange} required={!id} />
            </div>

            <div className="formGroup">
              <label>Learning Category</label>
              <select
                name="learningcategory"
                value={formData.learningcategory || ""}
                onChange={handleChange}
                required
              >
                <option value="" disabled>Learning Category</option>
                {learningcategory.map((chapter) => (
                  <option key={chapter.id} value={chapter.id}>
                    {chapter.name}
                  </option>
                ))}
              </select>
            </div>
          </div>


          <div className="formActions">
            <Button type="submit" className="submitButton">{id ? "Update" : "Submit"}</Button>
            <button type="button" className="backButton" onClick={() => navigate("/learning")}>
              Cancel
            </button>
          </div>

        </form>
        {previewImage && (
          <div
            onClick={() => setPreviewImage(null)}
            style={{
              position: "fixed",
              top: 0,
              left: 0,
              width: "100vw",
              height: "100vh",
              background: "rgba(0,0,0,0.85)",
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              zIndex: 99999,
              cursor: "pointer",
            }}
          >
            <img
              src={previewImage}
              alt="Preview"
              style={{
                maxWidth: "90%",
                maxHeight: "90%",
                borderRadius: "10px",
                boxShadow: "0 0 25px rgba(255,255,255,0.5)",
              }}
              onClick={(e) => e.stopPropagation()}
            />
          </div>
        )}


      </div>
    </div>
  );
};

export default AddLearningModuleMaster;
